import React from 'react';
import {Box, keyframes} from '@mui/material';
import LogoXMed from '../../assets/images/Logo-XMed-blue.png';
import {useTranslation} from "react-i18next";
// Pulse animation
const pulse = keyframes`
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.1);
        opacity: 0.7;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
`;

// Rotating ring animation
const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

// Fade in animation
const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const LogoLoader = ({size = 80, showText = true}) => {
    const {t} = useTranslation();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: '100vw',
                backgroundColor: '#f5f5f5',
                animation: `${fadeIn} 0.3s ease-in`,
            }}
        >
            {/* Loader container */}
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {/* Rotating ring around logo */}
                <Box
                    sx={{
                        position: 'absolute',
                        width: size + 40,
                        height: size + 40,
                        borderRadius: '50%',
                        border: '3px solid transparent',
                        borderTopColor: '#96e3ff',
                        borderRightColor: '#96e3ff',
                        animation: `${rotate} 1.2s linear infinite`,
                    }}
                />

                {/* Secondary rotating ring (opposite direction) */}
                <Box
                    sx={{
                        position: 'absolute',
                        width: size + 24,
                        height: size + 24,
                        borderRadius: '50%',
                        border: '2px solid transparent',
                        borderBottomColor: '#408ca8',
                        borderLeftColor: '#408ca8',
                        animation: `${rotate} 1.5s linear infinite reverse`,
                    }}
                />

                {/* Logo with pulse animation */}
                <Box
                    component="img"
                    src={LogoXMed}
                    alt="XMed Loading"
                    sx={{
                        width: size,
                        height: 'auto',
                        animation: `${pulse} 1.5s ease-in-out infinite`,
                        zIndex: 1,
                    }}
                />
            </Box>

            {/* Loading text */}
            {showText && (
                <Box
                    sx={{
                        mt: 3,
                        color: '#408ca8',
                        fontSize: '1rem',
                        fontWeight: 500,
                        letterSpacing: '0.1em',
                        animation: `${pulse} 1.5s ease-in-out infinite`,
                    }}
                >
                    {t("Loading")}
                </Box>
            )}
        </Box>
    );
};

export default LogoLoader;
